export const redirectUrlsAfterPaymentSuccess = {
  exam: '/dashboard/events/my-events',
  event: '/dashboard/events/my-events',
}



// WEBPACK FOOTER //
// ./src/components/common/credit/PaymentSuccess/helpers.js